import { toast } from "react-toastify";
import { getMediumsList, saveMediumItems as saveMediumItemsReq } from "../../requests/mediums";
export const types = {
  GET_MEDIUMS_REQUEST: 'GET_MEDIUMS_REQUEST',
  GET_MEDIUMS_SUCCESS: 'GET_MEDIUMS_SUCCESS',
  GET_MEDIUMS_FAILURE: 'GET_MEDIUMS_FAILURE',
  GET_MEDIUM_REQUEST: 'GET_MEDIUM_REQUEST',
  GET_MEDIUM_SUCCESS: 'GET_MEDIUM_SUCCESS',
  GET_MEDIUM_FAILURE: 'GET_MEDIUM_FAILURE',
  SAVE_MEDIUM_REQUEST: 'SAVE_MEDIUM_REQUEST',
  SAVE_MEDIUM_SUCCESS: 'SAVE_MEDIUM_SUCCESS',
  SAVE_MEDIUM_FAILURE: 'SAVE_MEDIUM_FAILURE',
}

export const getMediums = () => {
  return (dispatch) => {
    dispatch({ type: types.GET_MEDIUMS_REQUEST });
    getMediumsList()
      .then(response => {
        dispatch({
          type: types.GET_MEDIUMS_SUCCESS,
          payload: response.data.map(medium => ({
            ...medium,
            items: medium.items.map(item => ({
              ...item,
              chId: item.automaticId || item.promotedId || item.liveId,
              data: undefined
            }))
          }))
        });
      })
      .catch(err => {
        dispatch({
          type: types.GET_MEDIUMS_FAILURE,
          err
        })
      })
  }
}

export const saveMediumItems = data => {
  return (dispatch) => {
    dispatch({ type: types.SAVE_MEDIUM_REQUEST, id: data.id });
    saveMediumItemsReq(data)
      .then(() => {
        dispatch({
          type: types.SAVE_MEDIUM_SUCCESS
        })
        toast.success('تغییرات با موفقیت ذخیره شد', {toastId: 'medium-saved'})
      })
      .catch(error => {
        dispatch({
          type: types.SAVE_MEDIUM_FAILURE,
          error
        })
      })
  }
}
